import '$lib/services/polyfills';
import { readable } from 'svelte/store';
import type { CometDSingleton } from '$lib/services/cometd/cometd';
import { browser } from '$app/environment';
import { getContext, setContext } from 'svelte';

// Promise forever pending SSR
const { promise: instance, resolve, reject } = Promise.withResolvers<CometDSingleton>();

const cometd = readable<CometDSingleton | undefined>(undefined, (set) => {
    instance.then(set);
    return () => set(undefined);
});

if (browser) {
    import('$lib/services/cometd/cometd').then(({ default: cometdInstance }) => {
        resolve(cometdInstance);
    }, reject);
}

const cometdContextKey = Symbol('cometd');

export const setCometDContext = () => {
    if (getContext(cometdContextKey)) return;
    setContext(cometdContextKey, cometd);
};

export const getCometDContext = () => getContext<typeof cometd>(cometdContextKey);
